import {
    apiRequest,
    uploadpresensi,
    download_template_uploadpresensi
} from "../../../../../services/adapters/kepegawaian/presensiService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", uploadpresensi, {
            body: query
        }, true)
    }
    fetchDownloadTemplate = async (query) => {
        return await apiRequest("get", download_template_uploadpresensi, {
            body: query
        }, true)
    }
}

export default CreateRepository